import React from "react";
import { translate } from "react-i18next";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

class SimplePieChart extends React.Component {
  filterData(data) {
    let result = data.filter((item) => {
      return item.value !== 0;
    });
    const { t } = this.props;
    result.forEach((item) => {
      item.name = t(item.name);
      item.key = t(item.key);
    });
    return result;
  }

  render() {
    let data = this.filterData(this.props.data);
    return (
      <ResponsiveContainer width={"100%"} height={240}>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={data}
            // dataKey={''}
            dataKey="value"
            cx={"50%"}
            cy={"50%"}
            innerRadius={"40%"}
            outerRadius={"100%"}
            fill="#8884d8"
          >
            {data.map((entry, index) => {
              return <Cell fill={entry.color} key={index} />;
            })}
          </Pie>
          {/* <Pie isAnimationActive={false} data={data02} cx={'50%'} cy={'50%'} outerRadius={80} fill="#8884d8" label/> */}
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default translate("translations")(SimplePieChart);
